import type { FC, MouseEvent, ReactNode } from 'react';
import FocusLock from 'react-focus-lock';
import styled, { css } from 'styled-components';
import { zindex } from 'app/shared/styles/_zindex';

import IconX from 'images/icons/x.svg';

interface OverlayProps {
  children: ReactNode;
  onHidePopup: (e?: MouseEvent) => void;
  overlayOffset?: string | null;
  shouldLockFocus?: boolean;
}

interface StyledOverlayProps {
  overlayOffset?: string | null;
}

const StyledOverlay = styled.div<StyledOverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: ${zindex['$z-index-under-header']};
  overflow: hidden;
  background: rgba(242, 242, 242, 0.8);
  backdrop-filter: blur(5px);

  ${(props) =>
    props &&
    props.overlayOffset &&
    css`
      top: ${props.overlayOffset};
      height: calc(100% - ${props.overlayOffset});
    `}
`;

const StyledCloseButton = styled.button`
  padding: 16px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index: ${zindex['$z-index-step']};
`;

const Overlay: FC<OverlayProps> = ({ children, onHidePopup, overlayOffset = null, shouldLockFocus = false }) => {
  return (
    <FocusLock autoFocus={false} returnFocus={true} disabled={!shouldLockFocus}>
      <StyledOverlay overlayOffset={overlayOffset}>
        {children}
        <StyledCloseButton onClick={onHidePopup} aria-label="Close overlay">
          <img src={IconX} height="16px" width="16px" alt="" />
        </StyledCloseButton>
      </StyledOverlay>
    </FocusLock>
  );
};

export default Overlay;
